var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.575,
    height: 30.618,
    viewBox: "0 0 30.575 30.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "block-user (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7853",
    d: "M10.849 14.772h2.844a7.278 7.278 0 0 1 2.942.607 1.067 1.067 0 1 0 .857-1.953 9.025 9.025 0 0 0-.834-.315 6.755 6.755 0 1 0-8.772 0 9.612 9.612 0 0 0-6.636 9.127v2.844a1.067 1.067 0 0 0 1.067 1.067h10.04a1.067 1.067 0 0 0 0-2.133H3.383v-1.778a7.475 7.475 0 0 1 7.466-7.466zM12.271 3.4a4.622 4.622 0 1 1-4.622 4.617A4.622 4.622 0 0 1 12.271 3.4z",
    transform: "translate(-1.25 -1.22)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7854",
    d: "M25.15 13.7a8.095 8.095 0 0 0-13.9 5.723 8.276 8.276 0 0 0 8.177 8.177 8.095 8.095 0 0 0 5.723-13.9zm-5.723-.321a6 6 0 0 1 3.445 1.09l-8.4 8.4a6.031 6.031 0 0 1 4.954-9.489zm0 12.088a6 6 0 0 1-3.445-1.09l8.4-8.4a6.031 6.031 0 0 1-4.954 9.489z",
    transform: "translate(2.971 3.013)",
    style: {
      fill: "currentColor"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteUser);
export default __webpack_public_path__ + "static/media/delete-user.9bc87b6979bcb4f5bb55dc7d1939d3b4.svg";
export { ForwardRef as ReactComponent };